import { c as _c } from "react/compiler-runtime";
import React from 'react';

/**
 * Props for the FileTypeIndicator component
 */
interface FileTypeIndicatorProps {
  readonly format: string;
}

/**
 * File Type Indicator Component
 * 
 * Displays a visual indicator for supported file formats.
 * Used in the upload area to show what types of files are accepted.
 * 
 * @param props Component props
 * @returns JSX Element
 */
const FileTypeIndicator: React.FC<FileTypeIndicatorProps> = t0 => {
  const $ = _c(2);
  const {
    format
  } = t0;
  let t1;
  if ($[0] !== format) {
    t1 = <span className="tw-px-3 tw-py-1.5 tw-rounded-full tw-bg-iron-900/50 tw-backdrop-blur tw-border tw-border-iron-800/50">{format}</span>;
    $[0] = format;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default FileTypeIndicator;